import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { ToastService, Toast } from '../../../core/services/toast.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit, OnDestroy {
  toasts: Toast[] = [];
  icons: Record<string, string> = {
    success: '✓',
    error:   '✕',
    warning: '⚠',
    info:    'ℹ'
  };
  private sub!: Subscription;

  constructor(public toast: ToastService) {}

  ngOnInit() {
    this.sub = this.toast.toasts$.subscribe(t => this.toasts = t);
  }

  ngOnDestroy() { this.sub.unsubscribe(); }
}
